import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_work_targets_production_e_g_quota_piece'

export const dataPointDefinition = {
  retracedId: 'are_work_targets_production_e_g_quota_piece',
  name: 'Are work targets for production (e.g. quota or piece work) in line with legal requirements?',
  description:
    'The intent of the question is to determine if the facility sets production volume targets for piece rate workers in line with legal requirements.',
  meta: {
    slcpMeta: {
      key: 'wh-wor-9',
      number: 'WH-WOR-14',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wh-wor-9', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36590,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
